import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const UpdateRateTemplate = () => {
  const [formData, setFormData] = useState({
    pincode: "",
    months: "",
    rate: "",
  });
  const { template_id } = useParams();
  const navigate = useNavigate();


// ..........................<Fetch Data By Id >.....................



  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = "https://api.kalmesh.in/BabyStepsAPI";

      try {
        const apiToken = sessionStorage.getItem("api_token");

        if (!apiToken) {
          console.error("API Token not found in session storage");
          // Handle the case where the API token is not found
          return;
        }
        const response = await fetch(`${apiUrl}/rate-template-list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            su_id: 1,
            api_token: apiToken,
            trans_from: "SUPER_ADMIN",
          }),
        });

        if (response.ok) {
          const data = await response.json();
          // console.log("Original Data:", data);

          if (data.data.length > 0) {
            // Filter data to include only entries where id is equal to template_id
            const filteredData = data.data.find(entry => entry.id === +template_id);
            // console.log("Filtered Data:", filteredData);

            if (filteredData) {
              // Set formData with the filtered data
              setFormData({
                pincode: filteredData.pincode,
                months: filteredData.months,
                rate: filteredData.rate,
              });
            } else {
              console.log("No matching data found for the template ID.");
            }
          } else {
            console.log("No data received from the API.");
          }
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error occurred while fetching data", error);
      }
    };

    fetchData();
  }, [template_id]);
  
  

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };




// ..........................<Update Code>.....................



  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // api token fetch 
      const apiToken = sessionStorage.getItem("api_token");

        if (!apiToken) {
          console.error("API Token not found in session storage");
          return;
        }

      // Update data fetch

      const apiUrl = "https://api.kalmesh.in/BabyStepsAPI"; // Replace with your actual API endpoint
      const response = await fetch(`${apiUrl}/update-rate-template`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          su_id: 1,
          is_activate: 1,
          api_token: apiToken,
          trans_from: "SUPER_ADMIN",
          template_id: template_id,
          ...formData,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log("Rate Updated successfully", responseData);
        
      if (responseData.status === "success") {
        // Display data from the API response on the console
        console.log("Record Updated Successfully");
        toast.success("Rate Updated successfully",{ autoClose: 1000 });

       
        // Now you can compare responseData.status for redirection
        navigate("/ratetempletelist");
        
      } else {
        console.error("Can't Update This Record");
        toast.error("Failed to Update Rate",{ autoClose: 1000 });

      }
        // Redirect to the page after successful update
       
      } else {
        console.error("Failed to Update Rate", response.statusText);
      }
    } catch (error) {
      console.error("Error occurred while Updating Rate", error);
      toast.error("Error occurred while Updating Rate",{ autoClose: 1000 });

    }
  };

  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <h1 className="h3 mb-4 text-gray-800">Update Rate Template</h1>
              <div className="card">
                <div className="card-header">Update Rate Template</div>
                <div className="card-body" style={{ background: "white" }}>
                  <form onSubmit={handleSubmit}>
                    <div className="container">
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Pin Code</label>
                            <input
                              type="number"
                              name="pincode"
                              className="form-control"
                              placeholder="Enter Pin Code"
                              value={formData.pincode}
                              onChange={handleInputChange}
                              readOnly  
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Months</label>
                            <input
                              type="number"
                              name="months"
                              className="form-control"
                              placeholder="Enter Month"
                              value={formData.months}
                              onChange={handleInputChange}
                              readOnly  
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Rate</label>
                            <input
                              type="text"
                              name="rate"
                              className="form-control"
                              placeholder="Enter Rate"
                              value={formData.rate}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                      >
                        Update Rate
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
